import { useContext, useEffect, useMemo, useState } from "react";

import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import NoData from "../../../../../../images/NoData.svg";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import Close from "../../../../../../images/Close.svg";
import { useLazyQuery } from "@apollo/client";
import {
  empType,
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../../../utils/Enum.types";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import useUrlParams from "../../../../../../customHooks/useUrlParams";

import {
  AtsStckItemDetailsEdges,
  AtsStckItemDetailsOrderField,
  filterDataType,
  GetItemsDetailsResult,
  GetItemsDetailsVars,
  ItemDetailsQueryType,
} from "../../items/queries/types";
import { GetItemsDetails } from "../../items/queries/queries";
import {
  DEFAULT_TIME,
  EMPTY_STRING,
  emptyFunc,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import { TableHeaderProps } from "../../../../../../utils/types";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import {
  CustomModal,
  getModifiedScrollHeight,
  handleMUISelectEvent,
  toInputStandardDate,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";
import useLabels from "../../../../../../customHooks/useLabels";
import Navbar from "../../../../../common/layout/Navbar";
import { Title } from "../../../../../../stories/Title/Title";
import Input from "../../../../../../stories/Input/Input";
import ItemGroupSelect from "../../../../../../customComponents/ItemGroupSelect";
import ItemCategorySelect from "../../../../../../customComponents/ItemCategorySelect";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../../styles/Variables";
import { Button } from "../../../../../../stories/Button/Button";

import {
  AddModalStyles,
  ImageModalStylesInTickets,
} from "../../../../../../styles/CustomModalStyles";
import ImportItemsDetails from "../../../item/ImportItemsDetails";
import Edit from "../../../../../../images/EditProfile.svg";
import Replace from "../../../../../../images/replace.svg";
import { modalOpertaionFlag } from "../../../../customer/Index";

import AddItemDetails from "./itemdetails/AddItemDetails";
import { payloadTypes } from "../../../../../../context/reducer";
import { AppContext } from "../../../../../../context/context";
import { getSubOrSiteOrJunctionByIdResult } from "./queries/types";
import { GetSubOrSiteOrJunctionById } from "./queries/queries";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import ReplaceStock from "../../../DashBoardMapsView/dashboardcomponents/vendor/ReplaceStock";
import {
  intialItemData,
  itemDataType,
} from "../../../DashBoardMapsView/dashboardcomponents/vendor/ResolveDetails";
import PoleNumComponent from "../../../../../common/Autocomplete/PoleNumComponent";
import { CustomTooltip } from "../../../../../../styles/TooltipStyles";

interface Props extends NavTypeProps {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
}

export interface NavTypeProps {
  NavType: LicenseTypes;
}

const JunctionsItemList = ({ NavType, setModalFlag, pageType }: Props) => {
  const { RetireItemList } = useAssetTableJson();
  const { state, dispatch } = useContext(AppContext);

  const { customer_id, sub_id, company_id, siteID, junctionID, item_id } =
    useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const navigate = useNavigate();
  const [items, setItems] = useState<AtsStckItemDetailsEdges[]>([]);
  const [importModal, setImportModal] = useState(false);

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [itemData, setItemData] = useState<itemDataType>(intialItemData);

  const [searchJunction, setSearchJunction] = useState("");
  const [filterData, setFilterData] = useState<filterDataType>({
    ItemGroupId: 0,
    ItemCategoryId: 0,
    UoMId: 0,
    poleNum: 0,
  });
  const [addModal, setAddModal] = useState<modalOpertaionFlag>({
    operation: Operation.CREATE,
    flag: false,
  });

  const [GetJunctionItems, { data, loading, fetchMore }] = useLazyQuery<
    GetItemsDetailsResult,
    GetItemsDetailsVars
  >(GetItemsDetails);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id || company_id) {
          GetJunctionItems({
            variables: {
              customerID: customer_id ? customer_id : 0,
              companyID: company_id ? company_id : 0,
              subsidiaryID: sub_id ? sub_id : 0,
              siteID: siteID ? siteID : 0,
              junctionID: junctionID ? junctionID : 0,
              input: {
                query_type: ItemDetailsQueryType.ALL,
                stckCategoryID: filterData.ItemCategoryId
                  ? filterData.ItemCategoryId
                  : 0,
                stckGroupID: filterData.ItemGroupId
                  ? filterData.ItemGroupId
                  : 0,
                stckManufacturerID: 0,
                stckUomID: filterData.UoMId ? filterData.UoMId : 0,
                stckSubCategoryID: 0,
                itemID: item_id ? Number(item_id) : 0,
                ldgrID: 0,
                empID: user_details.id!,
                poleNum: filterData.poleNum ? filterData.poleNum : undefined,
              },
              after: null,
              first: ROWS_PER_PAGE,
              name: searchJunction,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckItemDetailsOrderField.CREATED_AT,
              },
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [
    customer_id,
    sub_id,
    user_details.id,
    GetJunctionItems,
    searchJunction,
    filterData,
    item_id,
  ]);

  const dynamicHeaders: TableHeaderProps[] = RetireItemList.List.filter(
    (item) => item.field !== "retireDate",
  ).map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    cellClassName: header.cellClassName,
  }));
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      field: "actions",
      cellClassName: "td-actions-print ",
      headerClassName: "td-actions-print-header",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        if (state.empSubType === empType.TECHNICIAN) {
          const img = require(
            `../../../../../../images/ItemIcons/${
              params.row.icon ? params.row.icon : "item"
            }.svg`,
          );

          return (
            <CustomTooltip
              title={"Replace"}
              arrow
              placement="right"
              // slotProps={{
              //   tooltip: {
              //     sx: {
              //       bgcolor: TOOLTIP_COLORS.VARIABLE,
              //       "& .MuiTooltip-arrow": {
              //         color: TOOLTIP_COLORS.VARIABLE,
              //       },
              //     },
              //   },
              // }}
            >
              <img
                src={Replace}
                alt="/"
                style={{ filter: "invert(100%)" }}
                onClick={() => {
                  setItemData({
                    id: params.row.itemDetaildId,
                    img,
                    desc: params.row.description,
                    slNo: params.row.slNo,
                    prodSerialNo: params.row.prodSerialNo,
                    poleNum: params.row.poleNum,
                    prodBatchNo: params.row.prodBatchNo,
                    prodWarrantyStartDate: params.row.prodWarrantyStartDate,
                    prodWarrantyEndDate: params.row.prodWarrantyEndDate,
                    maintainedBy: params.row.maintainedBy,
                    siteLocation: params.row.siteLocation,
                    prodInstallationEndDate: params.row.prodInstallationEndDate,
                    remark: params.row.remark
                  });
                  setOpenModal(true);
                }}
              />
            </CustomTooltip>
          );
        } else {
          return (
            <>
              <img
                src={Edit}
                alt="/"
                onClick={() => {
                  dispatch({
                    type: payloadTypes.SET_ITEM_DETAILS_ID,
                    payload: {
                      itemDetailsId: params.row.itemDetaildId,
                    },
                  });
                  setAddModal({
                    operation: Operation.UPDATE,
                    flag: true,
                  });
                }}
              />
            </>
          );
        }
      },
    },
  ];

  const rows1: GridValidRowModel[] = useMemo(() => {
    return items.map(({ node: data }, index) => {
      return {
        id: index + 1,
        code: data.item.code,
        description: data.item.desc,
        group: data.item.groupDetails.groupName,
        category: data.item.categoryDetails.categoryName,
        sub_category: data.item.subCategoryDetails.subCategoryName,
        model: data.prodModel,
        uom: data.item.uomDetails.uomDesc,
        itemDetaildId: data.id,
        icon: data.item.icon,

        slNo: data.item?.slNo ?? 0,
        prodSerialNo: data.prodSerialNo,
        poleNum: data.poleNum,
        prodBatchNo: data.prodBatchNo,

        maintainedBy: data.vendorDetails.desc,
        siteLocation: `${data.prodLatitude}, ${data.prodLongitude}`,

        prodBrand: data.prodBrand,
        prodModel: data.prodModel,
        prodExpiryDate:
          toInputStandardDate(data.prodExpiryDate) !== DEFAULT_TIME
            ? toStandardDate(data.prodExpiryDate)
            : "-",
        prodWarrantyStartDate:
          toInputStandardDate(data.prodWarrantyStartDate) !== DEFAULT_TIME
            ? toStandardDate(data.prodWarrantyStartDate)
            : "-",
        prodWarrantyEndDate:
          toInputStandardDate(data.prodWarrantyEndDate) !== DEFAULT_TIME
            ? toStandardDate(data.prodWarrantyEndDate)
            : "-",
        prodInstallationEndDate:
          toInputStandardDate(data.prodInstallationEndDate) !== DEFAULT_TIME
            ? toStandardDate(data.prodInstallationEndDate)
            : "-",

        subsidiary: data.currentSubsidiary.name,
        company: data.currentCompany.name,
        item: data.item.desc,
        site: data.currentSite.name,
        junction: data.currentJunction.name,
        remark: data.remark
      };
    });
  }, [items]);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.ITEMS_LIST);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel,
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.ITEMS_LIST,
      JSON.stringify(newModel),
    );
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItemsDetails.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (sub) => sub.node.id === newCompany.node.id,
          );
          if (filteredStudent) {
            return {
              ...newCompany,

              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
      } else {
        setItems(newData);
      }
      setEndCursor(data.GetItemsDetails.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller",
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetItemsDetails.edges;
              const pageInfo = fetchMoreResult.GetItemsDetails.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetItemsDetails.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id,
                  ) !== -1,
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetItemsDetails: {
                  edges: [...items, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetItemsDetails.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable) scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [items, data]);

  const [getSubOrSiteOrJunctionById, { data: SubOrSiteOrJunctionData }] =
    useLazyQuery<{ node: getSubOrSiteOrJunctionByIdResult }, nodeVar>(
      GetSubOrSiteOrJunctionById,
    );
  useEffect(() => {
    const fetchSubsidiaryDetails = async () => {
      try {
        if (sub_id || siteID || junctionID) {
          getSubOrSiteOrJunctionById({
            variables: {
              id: junctionID
                ? junctionID
                : siteID
                  ? siteID
                  : sub_id
                    ? sub_id
                    : 0,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchSubsidiaryDetails();
  }, [sub_id, siteID, junctionID, getSubOrSiteOrJunctionById]);
  const { itemLabel } = useLabels();

  return (
    <>
      {pageType === PageFor.GENERAL && <Navbar NavType={NavType} />}
      {pageType === PageFor.GENERAL ? (
        <Title>
          {SubOrSiteOrJunctionData
            ? SubOrSiteOrJunctionData.node.name
            : EMPTY_STRING}{" "}
          {itemLabel} List
        </Title>
      ) : (
        <div className="item-ob__title">
          <Title>
            {SubOrSiteOrJunctionData
              ? SubOrSiteOrJunctionData.node.name
              : EMPTY_STRING}{" "}
            {itemLabel} List
          </Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
      )}

      <div
        className={`item-ob${pageType === PageFor.GENERAL ? "" : "__modal"}`}
      >
        <div className="item-ob__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchJunction(e.target.value);
              }}
            />
          </div>
          <div className="col-2">
            <ItemGroupSelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    ItemGroupId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    ItemGroupId: 0,
                  });
                }
              }}
              value={filterData.ItemGroupId}
              onKeyDown={handleMUISelectEvent}
              label={`${itemLabel} Group`}
            />
          </div>
          <div className="col-2">
            <ItemCategorySelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    ItemCategoryId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    ItemCategoryId: 0,
                  });
                }
              }}
              value={filterData.ItemCategoryId}
              label={`${itemLabel} Category`}
              onKeyDown={handleMUISelectEvent}
            />
          </div>
          <div className="col-2">
            <PoleNumComponent
              onChange={(newValue) => {
                setFilterData({
                  ...filterData,
                  poleNum: newValue,
                });
              }}
              onKeyDown={emptyFunc}
              value={filterData.poleNum ? filterData.poleNum : 0}
              label="Pole Number"
              poleNum={
                data
                  ? data.GetItemsDetails.edges[0].node.currentJunction.poles
                  : 0
              }
            />
          </div>
          {/* <div className="col">
                <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Sub Category"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div>
          <div className="col">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Manufacturer"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div> */}
        </div>
        <div className="item-ob__tableblock">
          {items.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows1}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <div className="row">
          <div className="col-2">
            {pageType === PageFor.GENERAL &&
            state.empSubType === empType.SYS_ADMIN ? (
              <Button
                mode="excel"
                type="button"
                onClick={() => setImportModal(true)}
              >
                Import {itemLabel}
              </Button>
            ) : null}
            {pageType === PageFor.GENERAL ? (
              <Button mode="back" onClick={() => navigate(-1)} />
            ) : (
              <Button mode="cancel" onClick={() => setModalFlag(false)} />
            )}
          </div>

          <div className="col"></div>
          <div className="col-2 flex-end">
            <div className="overall-total-count">
              Total Count <b>{data?.GetItemsDetails.totalCount}</b>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        isOpen={importModal}
        onRequestClose={() => setImportModal(!importModal)}
        contentComponent={
          <ImportItemsDetails
            setModalFlag={setImportModal}
            NavType={LicenseTypes.ADMIN}
            pageType={PageFor.MODAL}
            bulkAlterPage={false}
          />
        }
        style={AddModalStyles}
      />
      <Modal isOpen={addModal.flag} style={AddModalStyles} ariaHideApp={false}>
        <AddItemDetails
          setModalFlag={setAddModal}
          operation={addModal.operation}
        />
      </Modal>

      <CustomModal
        isOpen={openModal}
        onRequestClose={() => setOpenModal(false)}
        contentComponent={
          <ReplaceStock
            setOpenModal={setOpenModal}
            itemData={itemData}
            ticketId={0}
          />
        }
        style={ImageModalStylesInTickets}
      />
    </>
  );
};

export default JunctionsItemList;
